// @flow
import { type JSSThemeDefaultDropdownMenuType } from '../JSSThemeDefaultDropdownMenu';

export const JSSThemeDropdownMenu61900: JSSThemeDefaultDropdownMenuType = (
  themeVars
) => {
  const {
    colors: {
      colorTypes: { white, text3 },
    },
  } = themeVars;
  return {
    dropdownDesktop: {
      selectorWrap: {
        color: white,
      },
      item: {
        background: white,
        color: text3,
        '&:hover,&.active': { color: white },
      },
      list: {
        '&:before': {
          background: white,
        },
      },
    },

    dropdownMobile: {
      select: {
        color: white,
      },
      description: {
        color: white,
      },
      chevron: {
        color: white,
      },
    },
  };
};
